import Vue from "vue";
import Component from "vue-class-component";
import { CallPrice } from "@scrile/api-provider/dist/api/CallPriceProvider";
import { PaidCallType } from "@scrile/api-provider/dist/api/PaidCallsProvider";
import { ErrorDTO } from "@scrile/api-provider/dist/lib/apiErrorHandler";
import providers from "@/lib/api";

@Component
export default class WithPaidCalls extends Vue {
  public async paidCallsFindCallPrice(userId: string) {
    const response = await providers.CallPriceProvider.find({ userIds: [userId] });
    const price = response.find(i => i.userId === userId);
    if (!price) {
      const data: CallPrice = {
        userId,
        perMinuteAudioPriceId: "0",
        perMinuteVideoPriceId: "0",
        perMinuteAudioPricePackage: null,
        perMinuteVideoPricePackage: null,
      };
      return data;
    }
    return price;
  }

  public paidCallsSubscribeRequestPaymentForCall(onData: (callId: string) => void, onError?: (e: ErrorDTO[]) => void) {
    return providers.PaidCallsProvider.subscribeRequestPaymentForCall(onData, onError);
  }

  public updatePaidCall(callId: string, type: PaidCallType) {
    return providers.PaidCallsProvider.paidCallUpdate({ data: { callId, type } });
  }
}
